window.theme = window.theme || {};

theme.config = {
  mediaQuerySmall: 'screen and (max-width: 589px)',
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Feel Food (3.2.5) - Developed by Akshay Vaghasiya | Learn more at https://akshayvaghasiya.com');
}

/* ================ Theme Editor API ================ */
window.theme = window.theme || {};

theme.delegate = {
  on: function(event, callback, options){
    if( !this.namespaces ) // save the namespaces on the DOM element itself
      this.namespaces = {};

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split('.')[0], callback, options);
    return this;
  },
  off: function(event) {
    if (!this.namespaces) { return }
    this.removeEventListener(event.split('.')[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  }
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;


theme.a11y = {
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
      ? 'focusout.' + options.namespace
      : 'focusout',
      keydown: options.namespace
      ? 'keydown.' + options.namespace
      : 'keydown.handleFocus'
    };

    // Get every possible visible focusable element
    var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
    var elArray = [].slice.call(focusableEls);
    var focusableElements = elArray.filter(el => el.offsetParent !== null);

    var firstFocusable = focusableElements[0];
    var lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    document.documentElement.off('focusin');
    document.documentElement.on(eventsName.focusout, function() {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.container) {
      options.container.removeAttribute('tabindex');
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling: function(namespace, element) {
    var el = element ? element : document.documentElement;
    document.documentElement.classList.add('lock-scroll');
    el.on('touchmove' + namespace, function() {
      return true;
    });
  },

  unlockMobileScrolling: function(namespace, element) {
    document.documentElement.classList.remove('lock-scroll');
    var el = element ? element : document.documentElement;
    el.off('touchmove' + namespace);
  }
};

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
        'shopify:section:load',
        this._onSectionLoad.bind(this)
    );
    document.addEventListener(
        'shopify:section:unload',
        this._onSectionUnload.bind(this)
    );
    document.addEventListener(
        'shopify:section:select',
        this._onSelect.bind(this)
    );
    document.addEventListener(
        'shopify:section:deselect',
        this._onDeselect.bind(this)
    );
    document.addEventListener(
        'shopify:block:select',
        this._onBlockSelect.bind(this)
    );
    document.addEventListener(
        'shopify:block:deselect',
        this._onBlockDeselect.bind(this)
    );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor) {
        var id = container.getAttribute('data-section-id');
        var type = container.getAttribute('data-section-type');

        constructor = constructor || this.constructors[type];

        if (typeof constructor === 'undefined') {
            return;
        }

        var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function (evt) {
        var container = document.querySelector(
            '[data-section-id="' + evt.detail.sectionId + '"]'
        );

        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function (evt) {
        this.instances = this.instances.filter(function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (typeof instance.onUnload === 'function') {
                    instance.onUnload(evt);
                }
            }

            return !isEventInstance;
        });
    },

    _onSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onSelect === 'function'
        ) {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onDeselect === 'function'
        ) {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockSelect === 'function'
        ) {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        // eslint-disable-next-line no-shadow
        var instance = this.instances.find(function (instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockDeselect === 'function'
        ) {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor) {
        this.constructors[type] = constructor;

        document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
            function (container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    }
});

// Cart Refresh and Build Functions
function addToCartSuccess() {
  fetch("/cart?section_id=cart-drawer")
  .then(response => response.text())
  .then((data) => {
    const id = "CartDrawerForm";
    const html = new DOMParser().parseFromString(data, 'text/html')
    const destination = document.getElementById(id);
    const source = html.getElementById(id);

    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelector('#crt').classList.remove('loading');
    
    // Cart Timer Refresh
	document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
    
  }).catch((e) => {
    // handle error
    console.error(e);
  });
}


function refreshCart(cart) {
  var cartBubble = document.querySelector('.Header__CartDot');
  var EmptyCart = document.querySelector('.empty-cart');
  var NonEmptyCart = document.querySelector('.nonempty-cart');
  //console.log('Xxx');
  if(cart.item_count > 0){
    cartBubble.classList.add('is-visible');
    cartBubble.textContent = cart.item_count;
    EmptyCart.classList.add('hidden');
    NonEmptyCart.classList.remove('hidden');
  } else {
    cartBubble.classList.remove('is-visible');
    cartBubble.textContent = cart.item_count;
    EmptyCart.classList.remove('hidden');
    NonEmptyCart.classList.add('hidden');
  }
}

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    success: function(cart) { 
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  // Shopify returns a description of the error in XMLHttpRequest.responseText.
  // It is JSON.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

/*
 *======================
 * Cart Timer
 *======================
*/
theme.CartTimer = (function() {
  var checkout = {
    strings: {
      timerEndMessage: theme.settings.cartTimerEnd
    }
  };

  function currentDate(currentHash, varName, callback) {
    if (callback) {
      var date = new Date;
      date.setTime(date.getTime() + 60 * callback * 1000);
      var sufix = "; expires=" + date.toUTCString();
    } else {
      sufix = "";
    }
    document.cookie = currentHash + "=" + varName + sufix + "; path=/";
  }

  function resultDataCookie(selector) {
    var result = selector + "=";
    var definedDrops = document.cookie.split(";");
    var i = 0;
    for (; i < definedDrops.length; i++) {
      var def = definedDrops[i];
      for (; " " == def.charAt(0);) {
        def = def.substring(1, def.length);
      }
      if (0 == def.indexOf(result)) {
        return def.substring(result.length, def.length);
      }
    }
    return null;
  }

  function existingSourceCookie(newhash) {
    currentDate(newhash, "", -1);
  }

  function stTM(string, n, elem) {
    function showOrHideJumpToNewPostButton() {
      _ref4 = n - ((Date.now() - string) / 1000 | 0);
      id = _ref4 % 60 | 0;
      url = (url = _ref4 / 60 | 0) < 10 ? "0" + url : url;
      id = id < 10 ? "0" + id : id;
      elem.textContent = url + ":" + id;
      if (_ref4 <= 0) {
        clearInterval(chat_retry);
        const timerWrapper = document.querySelectorAll(".Timer__wrapper")
        for (const wrapper of timerWrapper) {
          wrapper.innerHTML = checkout.strings.timerEndMessage;
        }
        string = Date.now() + 1000;
      }
    }
    var _ref4;
    var url;
    var id;
    showOrHideJumpToNewPostButton();
    var chat_retry = setInterval(showOrHideJumpToNewPostButton, 1000);
  }

  window.initPCCS = init;

  function init() {
    var discountText,
        display;
    if (document.querySelector("#CartDrawerForm")) {
      var numAddresses = 600;
      var currentNumber = Date.now();
      var connectNumber = resultDataCookie("pRtC");
      if (connectNumber) {
        if (currentNumber < connectNumber) {
          numAddresses = (connectNumber - currentNumber) / 1000;
        } else {
          existingSourceCookie("pRtC");
          currentDate("pRtC", Date.now() + 1000 * numAddresses, numAddresses + 1);
        }
      } else {
        currentDate("pRtC", Date.now() + 1000 * numAddresses, numAddresses + 1);
      }

      const timers = document.querySelectorAll(".Time");
      for (const timer of timers) {
        stTM(currentNumber, numAddresses, timer);
      }
    }
  }

  // On Cart Timer Refresh Event Reload Timer again
  window.on('cartdrawer:refresh', function(event) {
    init();
  });            
              
  document.addEventListener('cartdrawer:refresh', function(event) {
    init();
  });

  var reloadTimer = debounce((event) => {
    // Cart Timer Refresh
    document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
  }, 800);
  
  return {
    init: init,
    reloadTimer: reloadTimer
  };
})(); 

var timerDebounce = debounce((event) => {
  // Cart Timer Refresh
  document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
}, 800);

// Trap Focus
function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');

    }, true);
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('.deferred-media video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

theme.Responsive = function () {
  function Responsive() {
    var _this = this;

    this.currentBreakpoint = _this.getCurrentBreakpoint();
    window.addEventListener('resize', function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(new CustomEvent('breakpoint:changed', {
        detail: {
          previousBreakpoint: _this.currentBreakpoint,
          currentBreakpoint: newBreakpoint
        }
      }));
      _this.currentBreakpoint = newBreakpoint;
    });
  }

  Responsive.prototype = Object.assign({}, Responsive.prototype, {
  
    matchesBreakpoint:function (breakpoint) {
      switch (breakpoint) {
        case 'phone':
          return window.matchMedia('screen and (max-width: 640px)').matches;

        case 'tablet':
          return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

        case 'tablet-and-up':
          return window.matchMedia('screen and (min-width: 641px)').matches;

        case 'pocket':
          return window.matchMedia('screen and (max-width: 1007px)').matches;

        case 'lap':
          return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

        case 'lap-and-up':
          return window.matchMedia('screen and (min-width: 1008px)').matches;

        case 'desk':
          return window.matchMedia('screen and (min-width: 1280px)').matches;

        case 'widescreen':
          return window.matchMedia('screen and (min-width: 1600px)').matches;

        case 'supports-hover':
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      }
    },
  
    getCurrentBreakpoint:function() {
      if (window.matchMedia('screen and (max-width: 640px)').matches) {
        return 'phone';
      }

      if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
        return 'tablet';
      }

      if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
        return 'lap';
      }

      if (window.matchMedia('screen and (min-width: 1280px)').matches) {
        return 'desk';
      }
    }
  });

  return Responsive;
}();

theme.Dom = (function() {
  /**
   * Get all the previous and next siblings, optionally filtered by a selector
  */
  function getSiblings(element, filter) {
    var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var siblings = [];
    var currentElement = element; // Do the previous first

    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    } // Then the next side


    currentElement = element;

    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  /**
     * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
     * we need to normalize it
     */
   function nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }

  /**
     * Calculate an element width with its margin
     */
   function outerWidthWithMargin(element) {
    var width = element.offsetWidth,
        style = getComputedStyle(element);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
   }

   /**
   * Calculate an element height with its margin
   */
    function outerHeightWithMargin(element) {
        var height = element.offsetHeight,
          style = getComputedStyle(element);
      height += parseInt(style.marginTop) + parseInt(style.marginBottom);
      return height;
    }

    return {
      getSiblings: getSiblings,
      nodeListToArray: nodeListToArray,
      outerWidthWithMargin: outerWidthWithMargin,
      outerHeightWithMargin: outerHeightWithMargin
    };
})();

theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.modal = document.getElementById(id);

    if (!this.modal) {
      return false;
    }

    this.modalContent = this.modal.querySelector('.modal__inner');

    this.config = Object.assign(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    document.querySelectorAll(this.config.open).forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', this.open.bind(this));
    });

    this.modal.querySelectorAll(this.config.close).forEach(btn => {
      btn.addEventListener('click', this.close.bind(this));
    });

    // Close modal if a drawer is opened
    document.addEventListener('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.modal.classList.add(this.config.openClass);

    document.documentElement.classList.add(this.config.bodyOpenClass);

    if (this.isSolid) {
      document.documentElement.classList.add(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    theme.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen,
      namespace: 'modal_focus'
    });

    document.dispatchEvent(new CustomEvent('modalOpen'));
    document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

    this.bindEvents();
  };

  Modal.prototype.close = function(evt) {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // Do not close modal if click happens inside modal content
    if (evt) {
      if (evt.target.closest('.js-modal-close')) {
        // Do not close if using the modal close button
      } else if (evt.target.closest('.modal__inner')) {
        return;
      }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);
    this.modal.classList.add(this.config.closingClass);

    document.documentElement.classList.remove(this.config.bodyOpenClass);
    document.documentElement.classList.add(this.config.bodyClosingClass);

    window.setTimeout(function() {
      document.documentElement.classList.remove(this.config.bodyClosingClass);
      this.modal.classList.remove(this.config.closingClass);
      if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
        this.activeSource.setAttribute('aria-expanded', 'false').focus();
      }
    }.bind(this), 500); // modal close css transition

    if (this.isSolid) {
      document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    theme.a11y.removeTrapFocus({
      container: this.modal,
      namespace: 'modal_focus'
    });

    document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    window.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.modal.on('click.modal', this.close.bind(this));
    }
  };

  Modal.prototype.unbindEvents = function() {
    document.documentElement.off('.modal');

    if (this.config.closeOffContentClick) {
      this.modal.off('.modal');
    }
  };

  return Modal;
})();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

if (!customElements.get('video-object')) {
  class VideoObject extends HTMLElement {
    constructor() {
      super();

      this.mediaId = this.dataset.mediaId;
      if (!this.mediaId) return;

      this.mediaType = this.dataset.mediaType;
      this.loaded = JSON.parse(this.dataset.loaded);

      this.bindEvents();
    }

    bindEvents() {
      this.coverButton = this.querySelector('.video__cover-button');

      this.coverButton.addEventListener('click', (event) => {
        this.pauseAllMedia();
        if (!this.loaded) {
          const content = document.createElement('div');
          content.appendChild(
            this.querySelector('template').content.firstElementChild.cloneNode(
              true
            )
          );

          this.loaded = true;
          this.dataset.loaded = true;
          this.appendChild(
            content.querySelector('video, model-viewer, iframe')
          ).focus();

          this.video = this.querySelector('video, model-viewer, iframe');
        }

        if (this.mediaType === 'youtube') this.loadYouTubeAPI();

        // isOutOfView(this, (target) => {
        //   this.pauseMedia();
        // });

        event.preventDefault();
      });
    }
 
    loadYouTubeAPI() {
      if (window.YT !== undefined) {
        theme.youTubeApiStatus = 'ready';
      }
      if (
        theme.youTubeApiStatus !== 'loaded' ||
        theme.youTubeApiStatus !== 'ready'
      ) {
        const script = document.createElement('script');
        script.id = `youtube-iframe-api`;
        script.src = `https://www.youtube.com/iframe_api`;
        script.async = true;
        script.onload = () => {
          theme.youTubeApiStatus = 'loaded';
        };
        document.body.append(script);
      }
      if (theme.youTubeApiStatus === 'ready') {
        this.player = new YT.Player(this.video.id, {
          events: {
            onReady: () => this.onPlayerReady(),
          },
        });
      } else {
        window.onYouTubeIframeAPIReady = () => {
          this.player = new YT.Player(this.video.id, {
            events: {
              onReady: () => {
                this.onPlayerReady();
                theme.youTubeApiStatus = 'ready';
              },
            },
          });
        };
      }
    }

    onPlayerReady(player) {
      this.player.playVideo();
      // isOutOfView(this, (target) => {
      //   this.player.pauseVideo();
      // });
    }

    pauseMedia() {
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
          '*'
        );
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());
      this.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
          '*'
        );
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

  }
  customElements.define('video-object', VideoObject);
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

if (!customElements.get('slider-component')) {
  class MediaSlideshow extends HTMLElement {
    constructor() {
      super();

      let mainSlider = (this.mediaSlideshow = this.querySelector('[data-productgallery]'));

      if (!mainSlider) return;
      this.slides = this.mediaSlideshow.querySelectorAll('.Product__media-item');
      let thumbnailSlider = (this.slideshowThumbnails = this.querySelector('.Product__thumbnail'));
      
      this.mediaThumbnailsScrolling = this.querySelector('.media__thumbnails--scrolling');
      if (this.mediaThumbnailsScrolling) {
        this.mediaThumbnails = this.mediaThumbnailsScrolling.querySelectorAll(
          '.media__thumbnail'
        );
      }

     this.bindEvents();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // Initialize  Slider once media visible
        this.initSlideshow();
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);

    }

    bindEvents() {
      if (this.mediaThumbnails) {
        this.mediaThumbnails.forEach((thumbnail,index) => {
          thumbnail.addEventListener('click', () => this.selectThumbnail(index));
        })
      }
    }
    
    initSlideshow() {
      // Main
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);
      })
      
      var config = {
        prevNextButtons: false,
        cellAlign: 'left',
        imagesLoaded: true,
        adaptiveHeight: true,
        initialIndex: 0,
        dragThreshold: 8,
        wrapAround: false
      }
      
      this.main = new Flickity(this.mediaSlideshow, config);

      this.main.on('change', (newIndex) => {
        var sliderIndex = newIndex;
        if (this.main.selectedCell.element.previousElementSibling) this.playPauseVideo(this.main.selectedCell.element.previousElementSibling, "pause");
      });
      
      this.main.on('settle', (newIndex) => {
        var sliderIndex = newIndex;
        this.playPauseVideo(this.main.selectedCell.element, "play");
      });

      // Resize Main
      this.main.on('ready', (event) => {
        this.onResize();
      });
      
      // Thumbnails
      if (this.slideshowThumbnails) {

        var thumbnailConfig = {
          "asNavFor": this.mediaSlideshow,
          "draggable": false,
          "percentPosition": false,
          "groupCells": "100%",
          "pageDots": false,
          "prevNextButtons": false
        }

       //this.thumbnails = new Flickity(this.slideshowThumbnails, thumbnailConfig);
      }
      
      // add this code
      Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
      };

      Flickity.createMethods.push('_createResizeClass');

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call( this );
        this.element.classList.add('flickity-resize');
      };
    }

    selectThumbnail(index) {
      const activeIndex = Number(index);

      this.main.select(activeIndex);
    }

    setActiveMedia(mediaId) {
      const activeSlide = this.querySelector(`.Product__media-item[data-media-id="${mediaId}"]`);
      if (!activeSlide) return;

      const activeSlideIndex = Number(activeSlide.dataset.slideIndex);
      this.main.select(activeSlideIndex);
    }
    
    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        this.main.resize();
        window.dispatchEvent(new Event('resize'));
      });

      this.slideshowResizeObserver.observe(this.mediaSlideshow);
      
      // Windows on Resize
      window.addEventListener('resize', function(event){
        this.main.resize();
        this.mediaSlideshow.querySelector('.flickity-viewport').style.height = null;
        window.dispatchEvent(new Event('resize'));
      }, false);
    }
    
    playPauseVideo(slide, control) {
      var currentSlide, slideType, startTime, player, video;
      currentSlide = (this.activeSlide = slide);
      if (!currentSlide) return; 
      
      let sliderElement = currentSlide.querySelector('.Product__SlideItem');
      slideType = sliderElement.dataset.videoHost;
      player = this.activeSlide.querySelector("iframe");
      startTime = 1;

      if (slideType === "vimeo") {
        switch (control) {
          case "play":
            if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
              postMessageToPlayer(player, {
                "method": "setCurrentTime",
                "value" : startTime
              });
            }
            postMessageToPlayer(player, {
              "method": "play",
              "value" : 1
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              "method": "pause",
              "value": 1
            });
            break;
        }
      } else if (slideType === "youtube") {
        switch (control) {
          case "play":
            postMessageToPlayer(player, {
              "event": "command",
              "func": "mute"
            });
            postMessageToPlayer(player, {
              "event": "command",
              "func": "playVideo"
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              "event": "command",
              "func": "pauseVideo"
            });
            break;
        }
      } else if (slideType === "video") {
        video = this.activeSlide.querySelector("video");
        if (video != null) {
          if (control === "play"){
            video.play();
          } else {
            video.pause();
          }
        }
      }
    }

  }
  customElements.define('slider-component', MediaSlideshow);
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.additionalCallback();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const mediaSlideshow = document.getElementById(
      `MediaSlideshow-${this.dataset.section}`
    );
    mediaSlideshow.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', this.dataset.url+'?variant='+this.currentVariant.id);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll('#product-form-'+this.dataset.section);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      
      //Variant selection changed
      const currentVariant = this.currentVariant;
      document.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: currentVariant
        }
      }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(this.dataset.url+'?variant='+this.currentVariant.id+'&section_id='+this.dataset.section)
      .then((response) => response.text())
      .then((responseText) => {
        const id = "price-"+this.dataset.section;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;
        
        //Update Sticky Area
        const stickyId = "productSticky-"+this.dataset.section;
        const StickyDestination = document.getElementById(stickyId);
        const StickySource = html.getElementById(stickyId);
        if (StickySource && StickyDestination) StickyDestination.innerHTML = StickySource.innerHTML;

        document.getElementById('price-'+this.dataset.section)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        
        // Saving Badge
        const badge_id = "badge-"+this.dataset.section;
        const badgehtml = new DOMParser().parseFromString(responseText, 'text/html')
        const BadgeDestination = document.getElementById(badge_id);
        const BadgeSource = badgehtml.getElementById(badge_id);

        if (BadgeSource && BadgeDestination) BadgeDestination.innerHTML = BadgeSource.innerHTML;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.querySelector('[name="add"]');
    const btnText = addButton.querySelector('.Btn_Text');
    const StickyButton = document.querySelector('.component-atc-button'); 
    const StickyText = StickyButton.querySelector('.Btn_Text');
        
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) btnText.textContent = text;
      StickyButton.setAttribute('disabled', true);
      if(StickyText) StickyText.textContent = text;  
      
    } else {
      addButton.removeAttribute('disabled');
      btnText.textContent = window.variantStrings.addToCart;
      StickyButton.removeAttribute('disabled');
      StickyText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }
       
  additionalCallback() {
    var variant = this.currentVariant;
    const productForms = document.querySelectorAll('#product-form-' + this.dataset.section);
    const FormButtons = document.querySelector('.product-form__buttons');
    const NotifyButton = document.querySelector('.Back--In__stock');

    if (variant) {
        const BISButton = NotifyButton.querySelector('#BIS_trigger');
        if (BISButton) BISButton.dataset.variantId = variant.id;
    }

    if (variant && variant.available) {
        if (FormButtons) FormButtons.removeAttribute('hidden');
        if (NotifyButton) NotifyButton.setAttribute('hidden', '');
    } else {
        if (FormButtons) FormButtons.setAttribute('hidden', '');
        if (NotifyButton) NotifyButton.removeAttribute('hidden');
    }
  }      

  setUnavailable() {
    const addButton = document.querySelector('[name="add"]');
    const btnText = addButton.querySelector('.Btn_Text');
    if (!addButton) return;
    btnText.textContent = window.variantStrings.unavailable;
    document.getElementById('price-'+this.dataset.section)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

if (!customElements.get('popup-slider')) {
  class PopUpshow extends HTMLElement {
    constructor() {
      super();

      let mainSlider = (this.mediaSlideshow = this.querySelector('[data-productgallery]'));

      if (!mainSlider) return;
      this.slides = this.mediaSlideshow.querySelectorAll('.Product__media-item');
      let thumbnailSlider = (this.slideshowThumbnails = this.querySelector('.Product__thumbnail'));
      
      this.mediaThumbnailsScrolling = this.querySelector('.media__thumbnails--scrolling');
      if (this.mediaThumbnailsScrolling) {
        this.mediaThumbnails = this.mediaThumbnailsScrolling.querySelectorAll(
          '.media__thumbnail'
        );
      }

     this.bindEvents();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        // Initialize  Slider once media visible
        this.initSlideshow();
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);

    }

    bindEvents() {
      if (this.mediaThumbnails) {
        this.mediaThumbnails.forEach((thumbnail,index) => {
          thumbnail.addEventListener('click', () => this.selectThumbnail(index));
        })
      }
    }
    
    initSlideshow() {
      // Main
      this.slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', index);
      })
      
      var config = {
        prevNextButtons: false,
        cellAlign: 'left',
        imagesLoaded: true,
        adaptiveHeight: true,
        initialIndex: 0,
        dragThreshold: 8,
        wrapAround: true
      }
      
      this.main = new Flickity(this.mediaSlideshow, config);

      this.main.on('change', (newIndex) => {
        var sliderIndex = newIndex;
        if (this.main.selectedCell.element.previousElementSibling) this.playPauseVideo(this.main.selectedCell.element.previousElementSibling, "pause");
      });
      
      this.main.on('settle', (newIndex) => {
        var sliderIndex = newIndex;
        this.playPauseVideo(this.main.selectedCell.element, "play");
      });

      // Resize Main
      this.main.on('ready', (event) => {
        this.onResize();
      });
      
      // Thumbnails
      if (this.slideshowThumbnails) {

        var thumbnailConfig = {
          "asNavFor": this.mediaSlideshow,
          "draggable": false,
          "percentPosition": false,
          "groupCells": "100%",
          "pageDots": false,
          "prevNextButtons": false
        }

       //this.thumbnails = new Flickity(this.slideshowThumbnails, thumbnailConfig);
      }
      
      // add this code
      Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
      };

      Flickity.createMethods.push('_createResizeClass');

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call( this );
        this.element.classList.add('flickity-resize');
      };
    }

    selectThumbnail(index) {
      const activeIndex = Number(index);

      this.main.select(activeIndex);
    }

    setActiveMedia(mediaId) {
      const activeSlide = this.querySelector(`.Product__media-item[data-media-id="${mediaId}"]`);
      if (!activeSlide) return;

      const activeSlideIndex = Number(activeSlide.dataset.slideIndex);
      this.main.select(activeSlideIndex);
    }
    
    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        this.main.resize();
        window.dispatchEvent(new Event('resize'));
      });

      this.slideshowResizeObserver.observe(this.mediaSlideshow);
      
      // Windows on Resize
      window.addEventListener('resize', function(event){
        this.main.resize();
        this.mediaSlideshow.querySelector('.flickity-viewport').style.height = null;
        window.dispatchEvent(new Event('resize'));
      }, false);
    }
    
    playPauseVideo(slide, control) {
      var currentSlide, slideType, startTime, player, video;
      currentSlide = (this.activeSlide = slide);
      if (!currentSlide) return; 
      
      let sliderElement = currentSlide.querySelector('.Product__SlideItem');
      slideType = sliderElement.dataset.videoHost;
      player = this.activeSlide.querySelector("iframe");
      startTime = 1;

      if (slideType === "vimeo") {
        switch (control) {
          case "play":
            if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
              postMessageToPlayer(player, {
                "method": "setCurrentTime",
                "value" : startTime
              });
            }
            postMessageToPlayer(player, {
              "method": "play",
              "value" : 1
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              "method": "pause",
              "value": 1
            });
            break;
        }
      } else if (slideType === "youtube") {
        switch (control) {
          case "play":
            postMessageToPlayer(player, {
              "event": "command",
              "func": "mute"
            });
            postMessageToPlayer(player, {
              "event": "command",
              "func": "playVideo"
            });
            break;
          case "pause":
            postMessageToPlayer(player, {
              "event": "command",
              "func": "pauseVideo"
            });
            break;
        }
      } else if (slideType === "video") {
        video = this.activeSlide.querySelector("video");
        if (video != null) {
          if (control === "play"){
            video.play();
          } else {
            video.pause();
          }
        }
      }
    }

  }
  customElements.define('popup-slider', PopUpshow);
}
       
if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading-spin')) return; 

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading-spin');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        
        window.location.href = "/cart";
        /*
        addToCartSuccess();
        $.getJSON('/cart.js', function(cart){
          refreshCart(cart);
        });
        $('body').addClass('cartOpen');
        $('.fullPage').addClass('witmenu');
        $('#CartDrawer').attr("aria-hidden", "false");
        $('.PageOverlay').addClass('is-visible');
        
        // Cart Timer Refresh
        document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));  
        */          
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
      submitButton.classList.remove('loading-spin');
      submitButton.removeAttribute('aria-disabled');

    // Cart Timer Refresh
      //document.dispatchEvent(new CustomEvent('cartdrawer:refresh'));
    });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  });
}

theme.MobileNavigation = (function() {
  function MobileNavigation(element) {
    
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.documentElement);
    this.mobileMenuElement = this.element.querySelector('.mobile-menu');
    this.mobileMenuToggleElement = this.element.querySelector("[aria-controls=\"".concat(this.mobileMenuElement.id, "\"]"));
    this.isOpen = false;

    this._attachListeners();
  }

  MobileNavigation.prototype = Object.assign({}, MobileNavigation.prototype, {
  
  destroy: function () {
    this.delegateElement.off();
    this.delegateRoot.off();
    window.removeEventListener('resize', this._calculatMaxHeightListener);
  },

  _attachListeners: function () {
    this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this);
    this.delegateElement.on('click', '[data-action="toggle-menu"]', this._toggleMenu.bind(this));
    this.delegateRoot.on('click', this._onWindowClick.bind(this));
    window.addEventListener('resize', this._calculatMaxHeightListener);
  },

  _toggleMenu: function () {
    this.isOpen = !this.isOpen;
    this.mobileMenuToggleElement.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');
    this.mobileMenuElement.setAttribute('aria-hidden', this.isOpen ? 'false' : 'true');

    if (!this.isOpen) {
      this.mobileMenuElement.style.maxHeight = ''; // If closed, we need to close all sub-menus

      document.body.classList.remove('no-mobile-scroll');
      document.querySelector('#shopify-section-header').classList.remove('no-transparent-background');
    } else {
      // We need to restrict the height
      this._calculateMaxHeight();

      document.body.classList.add('no-mobile-scroll');
      document.querySelector('#shopify-section-header').classList.add('no-transparent-background');
    }
  },
   
  _calculateMaxHeight: function () {
    if (this.isOpen) {
      this.mobileMenuElement.style.maxHeight = "".concat(window.innerHeight - document.querySelector('.Header').getBoundingClientRect().bottom, "px");
    }
  },

  _onWindowClick: function (event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this._toggleMenu();
    }
  }
});

  return MobileNavigation;
})();

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }


    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    //this.closeMenuDisclosure();
    //this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  /*
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }*/
}

customElements.define('sticky-header', StickyHeader);


theme.HeaderSection = (function() {

  function HeaderSection(container) {
    var _this = this;

    this.element = container;
    this.delegateElement = new Delegate(this.element);
  
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.lastScrollPosition = -1;
    this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;

    if (this.options['isSticky']) {
      //Stickyfill.addOne(this.element.parentNode);
    }

    this._attachListeners();

    this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS
    
    var mainLogo = this.element.querySelector('.Header__LogoImage--primary');

    if (mainLogo && !mainLogo.complete) {
      mainLogo.addEventListener('load', function () {
        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
          document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
        });
      });
    } else {
      fastdom.measure(function () {
        document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
        document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
      });
    }

    var mobileNavigationElement = this.element.querySelector('.header__mobile-nav');

    if (mobileNavigationElement) {
      this.mobileNavigation = new theme.MobileNavigation(mobileNavigationElement);
    }

    window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));
  }
  
  HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
    onUnload: function() {
      this.element.removeEventListener('mouseleave', this._closeNavigationListener);
      this.element.removeEventListener('mouseenter', this._focusNavigationListener);
      this.element.removeEventListener('focusin', this._focusNavigationListener);
      this.delegateElement.off();
      window.removeEventListener('scroll', this._checkTransparentHeaderListener);
      window.removeEventListener('resize', this._verifyNavigationOverlapListener);

      if (this.options['isSticky']) {
        //Stickyfill.removeOne(this.element.parentNode);
      }

      if (this.mobileNavigation) {
        this.mobileNavigation.destroy();
      }

    },

    onSelect: function() {
      this._checkTransparentHeader();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(event) {
      var _this2 = this;

      var listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(function () {
        event.target.setAttribute('aria-hidden', 'false');

        if (listItem) {
          listItem.classList.add('is-expanded');
          theme.Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
          });
        }

        _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible

      });
    },

    onBlockDeselect: function(event) {
      var listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(function () {
        event.target.setAttribute('aria-hidden', 'true');

        if (listItem) {
          listItem.classList.remove('is-expanded');
        }
      });

      this._checkTransparentHeader();
    },

    _attachListeners: function() {
      this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
      this._closeNavigationListener = this._closeNavigation.bind(this);
      this._focusNavigationListener = this._focusNavigation.bind(this);
      this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
      this.element.addEventListener('mouseleave', this._closeNavigationListener);
      this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
      this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), false);
      this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
      this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
      this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);
      this.delegateElement.on('click', '[data-action="toggle-menu"]', this._focusMobileNavigation.bind(this));

      if (this.isTouch) {
        this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
      }

      if (this.options['hasTransparentHeader']) {
        this.element.addEventListener('mouseenter', this._focusNavigationListener);
        this.element.addEventListener('focusin', this._focusNavigationListener);
      }

      if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
        window.addEventListener('scroll', this._checkTransparentHeaderListener);
      }

      if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
        window.addEventListener('resize', this._verifyNavigationOverlapListener);
      }
    },

    _focusNavigation: function() {
      var _this3 = this;

      fastdom.mutate(function () {
        // if (!_this3.isTouch || window.matchMedia('screen and (min-width: 1008px)').matches) {
        //   _this3.element.classList.remove('Header--transparent');
        // }
        _this3.element.classList.remove('Header--transparent');
      });
    },

    
    _focusMobileNavigation: function() {
        var _this7 = this;
        
      
        fastdom.mutate(function () {
          if(_this7.element.classList.contains('Header--transparent')) {
            _this7.element.classList.remove('Header--transparent');
          }
        });
    },

    _closeNavigation: function() {
      var _this4 = this;

      fastdom.mutate(function () {
        theme.Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
          item.classList.remove('is-expanded');
        });
        theme.Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });

      if (this.options['hasTransparentHeader']) {
        this._checkTransparentHeader();
      }
    },

    _openMenu: function(event, target) {
      if (event.type === 'mouseenter' && target !== event.target) {
          return;
        }

        fastdom.mutate(function () {
          target.classList.add('is-expanded');

          theme.Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
            item.setAttribute('aria-hidden', 'false');
          });
          theme.Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
            item.classList.remove('is-expanded');
            theme.Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
            });
          });
        });
    },

    _closeMenu: function(event, target) {
      if (event.type === 'mouseleave' && target !== event.target) {
          return;
      }

      fastdom.mutate(function () {
        target.classList.remove('is-expanded');
        theme.Dom.nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      });
    },

    _adjustDropdownPosition: function(event, target) {
          var nestedMenus = theme.Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
          shouldOpenLeft = false;
      fastdom.measure(function () {
          var windowWidth = window.innerWidth,
              rightEdge = target.getBoundingClientRect().right;
          nestedMenus.forEach(function (item) {
          if (rightEdge + item.offsetWidth > windowWidth) {
              shouldOpenLeft = true;
          }
          });
      });
      fastdom.mutate(function () {
          if (shouldOpenLeft) {
          nestedMenus.forEach(function (item) {
              item.classList.add('DropdownMenu--reversed');
          });
          } else {
          nestedMenus.forEach(function (item) {
              item.classList.remove('DropdownMenu--reversed');
          });
          }
      });
    },

    _handleTouchMenu: function(event, target) {
      if (!target.classList.contains('is-expanded')) {
          event.preventDefault();
        }
    },

    _verifyNavigationOverlap: function() {
      var _this5 = this;

      var isOverlapping = false,
          mainTopMenu = this.element.querySelector('.Header__MainNav');
      fastdom.measure(function () {
        // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
        if (mainTopMenu) {
          // Get the first element
          var firstNavElementHeight = theme.Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
              mainNavHeight = mainTopMenu.scrollHeight;

          if (mainNavHeight > firstNavElementHeight) {
            isOverlapping = true;
          }
        }
      });
      this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
      this.element.classList.add("Header--".concat(this.options['navigationStyle']));
      this.element.clientWidth; // Forces a reflow

      fastdom.mutate(function () {
        if (isOverlapping) {
          _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));

          _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode


          if (mainTopMenu) {
            // Get the first element
            var itemTopSet = new Set();
            Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
              itemTopSet.add(item.getBoundingClientRect().top);
            });
            isOverlapping = itemTopSet.size > 1;
          }
        } else {
          _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));

          _this5.element.classList.remove('Header--center');
        }

        var logo = _this5.element.querySelector('.Header__FlexItem--logo');

        logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);

        _this5.element.classList.add('Header--initialized');

        fastdom.measure(function () {
          document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
        });
      });
    },

    _checkTransparentHeader: function() {
      var _this6 = this;

      if (!this.options['hasTransparentHeader']) {
        return;
      }

      var scrollThreshold = 10;
      fastdom.measure(function () {
        _this6.lastScrollPosition = window.pageYOffset;
      });
      fastdom.mutate(function () {
        if (_this6.lastScrollPosition <= scrollThreshold) {
          _this6.element.classList.add('Header--transparent');
        } else {
          _this6.element.classList.remove('Header--transparent');
        }
      });
    }

  });

  return HeaderSection;
})();


theme.Collapsible = (function() {
  function Collapsible() {
    var _this = this;
    this.domDelegate = new Delegate(document.body);
    this._attachListeners(); 
  }

  Collapsible.prototype = Object.assign({}, Collapsible.prototype, {
    _attachListeners: function() {
      this.domDelegate.on('click', '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this));
      
      document.addEventListener('collapsible:toggle', this._toggleCollapsible.bind(this));
    },

    /**
     * Toggle a given collapsible
     */

    _toggleCollapsible: function(event, target) {
      var _this = this;
      
      // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
      var parentCollapsible = target.parentNode;

      if (parentCollapsible.classList.contains('Collapsible--autoExpand') && window.matchMedia('screen and (min-width: 641px)').matches) {
        return;
      }

      // If the target is null, it may be because someone has sent the global event "collapsible:toggle". If that the case
      // we can retrieve the toggle button by using the event.detail.id
      if (!target && event.detail) {
        target = document.querySelector("[aria-controls=\"".concat(event.detail.id, "\"]"));
      }

      var isOpen = target.getAttribute('aria-expanded') === 'true',
          parentCollapsible = target.parentNode;

      if (isOpen) {
        this._close(parentCollapsible);
      } else {
        this._open(parentCollapsible);
      } // We make sure to close any siblings collapsible as well


      if (target.getAttribute('data-close-siblings') !== 'false') {
        theme.Dom.getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
          return _this._close(collapsibleToClose);
        });
      }
      event.preventDefault();
    },


    /**
     * Open a given collapsible
     */

   _open: function (collapsible) {
      var toggleButton = collapsible.querySelector('[aria-controls]');

      if (!toggleButton || toggleButton.getAttribute('aria-expanded') === 'true') {
        return; // It's already open
      }

      var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute('aria-controls')));
      toggleButton.setAttribute('aria-expanded', 'true');

      if (collapsibleContent.hasAttribute('aria-hidden')) {
        collapsibleContent.setAttribute('aria-hidden', 'false');
      }

      if (collapsibleContent.style.maxHeight === 'auto') {
        return;
      } // To do the animation we temporarily hide it, check the height, and transition to it
  
      collapsibleContent.style.maxHeight = "".concat(collapsibleContent.firstElementChild.scrollHeight, "px");

      if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
        collapsibleContent.style.overflow = 'visible';
      } 
      
      // If there is an autofocus field, we focus it
      var autofocusElement = collapsibleContent.querySelector('[autofocus]');

      if (autofocusElement) {
        autofocusElement.focus();
      }
    },
    /**
     * Close a given collapsible
     */

  _close:function (collapsible) {
      var toggleButton = collapsible.querySelector('[aria-controls]');

      if (!toggleButton || toggleButton.getAttribute('aria-expanded') === 'false') {
        return; // It's already closed
      }

      var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute('aria-controls')));

      if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
        collapsibleContent.style.overflow = 'hidden';
      }

      if (collapsibleContent.hasAttribute('aria-hidden')) {
        collapsibleContent.setAttribute('aria-hidden', 'true');
      }

      toggleButton.setAttribute('aria-expanded', 'false');
      collapsibleContent.style.maxHeight = "".concat(collapsibleContent.scrollHeight, "px"); // Force previous height to allow CSS transition
      collapsibleContent.offsetHeight; // Force redraw
      collapsibleContent.style.maxHeight = 0;
    }
    
  });

  return Collapsible;
})();

theme.FooterSection = (function() {

  function FooterSection(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    
    this._setupCollapsibles();

    this._attachListeners();
  }

  FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
    onUnload: function() {
      window.removeEventListener('resize', this._setupCollapsiblesListener);
      this.domDelegate.off();
    },
    
    _attachListeners: function() {
      this._setupCollapsiblesListener = this._setupCollapsibles.bind(this);
      window.addEventListener('resize', this._setupCollapsiblesListener);
    },

    /**
     * On mobile, block items are collapsed, so we must slightly edit their HTML
     */
    _setupCollapsibles: function() {
      var collapsibleToggles = this.element.querySelectorAll('[data-action="toggle-collapsible"]'),
          isPhone = window.matchMedia('screen and (max-width: 640px)').matches;

      collapsibleToggles.forEach(function (collapsibleToggle) {
        if (isPhone) {
          collapsibleToggle.removeAttribute('disabled');
        } else {
          collapsibleToggle.setAttribute('disabled', 'disabled');
          document.getElementById(collapsibleToggle.getAttribute('aria-controls')).style.height = '';
        }
      });
    }
  });

  return FooterSection;
})();

theme.CartCollection = (function() {

  function CartCollection(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = (this.slideshow = '#CartCollection-' + sectionId);

    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true
    }
    
	var flkty = new Flickity(this.slideshow, config);
    
    // add this code
    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };

  }

  return CartCollection;
})();


theme.RecommendationSlider = (function() {

  function RecommendationSlider(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = $(this.slideshow = '#Recommendation-' + sectionId);

    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true
    }
    
    function Recommendation() {
      if($('.Recommendations__Grid').length){ 

        var elem = document.querySelector('.Recommendations__Grid');
        var flkty = new Flickity( elem, {
          // options
          watchCSS: true,
          wrapAround: true,
          cellAlign: 'center',
          prevNextButtons: false,
          pageDots: false,
          imagesLoaded: true
        });

        
        // add this code
        Flickity.prototype._createResizeClass = function() {
          this.element.classList.add('flickity-resize');
        };

        Flickity.createMethods.push('_createResizeClass');

        var resize = Flickity.prototype.resize;
        Flickity.prototype.resize = function() {
          this.element.classList.remove('flickity-resize');
          resize.call( this );
          this.element.classList.add('flickity-resize');
        };

        
      } else {
        setTimeout(function(){
          Recommendation();	
        }, 1000);
      }
    }

    Recommendation();
  }

  return RecommendationSlider;
})();


class ProductTimer extends HTMLElement {
  constructor() {
    super();
    var _this1 = this;
    
    this.onTimerIntialize();
  }

  onTimerIntialize(container) {
    let _this2 = this;
    var $container = (this.$container = this);
    var $parent = $container.querySelector('.Product__dealArea');
    var sectionId = $parent.getAttribute('data-section-id');
    var DealTimer = this.$container.querySelector('#timer-' + sectionId);
    var endTime = $parent.getAttribute("data-enddate");
    
    // Set the date we're counting down to
    var countDownDate = new Date(endTime).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      let countedDays = days;
      
      if (days < 10) days = "0" + days;
      if (hours < 10) hours = "0" + hours;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      
      // Display the result in the element
      if (countedDays > 0 && countedDays > 7) {
        DealTimer.innerHTML = `kurze Zeit`;
      } else if (countedDays > 0 && countedDays <= 7) {
        DealTimer.innerHTML = `${days}:${hours}:${minutes}:${seconds}`;
      } else if (hours > 0) {
        DealTimer.innerHTML = `${hours}:${minutes}:${seconds}`;
      } else {
        DealTimer.innerHTML = `${minutes}:${seconds}`;
      }

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        if(_this2) _this2.setAttribute('hidden', '');
        let productDeal = _this2.querySelector('.Product__dealArea');
        if(productDeal) productDeal.style.display= "none";
      }
    }, 1000);
  }
  
}

customElements.define('product-timer', ProductTimer);


theme.InfluencerDeal = (function() {

  function InfluencerDeal(container) {
    var $container = (this.$container = container);
    var sectionId = $container.getAttribute('data-section-id');
    var DealTimer = $container.querySelector('#timer-' + sectionId);
    var endTime = $container.getAttribute("data-enddate");
    var endMessage = $container.getAttribute('data-end-message');
    
    // Set the date we're counting down to
    var countDownDate = new Date(endTime).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      // Display the result in the element
      if (days > 0) {
        DealTimer.innerHTML = `Nur noch ${days} Tage ${hours} Stunden, ${minutes} Minuten und ${seconds} Sekunden gültig.`;
      } else if (hours > 0) {
        DealTimer.innerHTML = `Nur noch ${hours} Stunden, ${minutes} Minuten und ${seconds} Sekunden gültig.`;
      } else {
        DealTimer.innerHTML = `Nur noch ${minutes} Minuten und ${seconds} Sekunden gültig.`;
      }

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        DealTimer.innerHTML = endMessage;
        var DiscountCode_Area = $container.querySelector('.Discount_codeArea');
        DiscountCode_Area.style.display= "none";
      }
    }, 1000);

  }

  return InfluencerDeal;
})();

theme.MultiColumn = (function() {

  function MultiColumn(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = '#MultiColumn-' + sectionId;

    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
    
    // add this code
    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };
  }
  
  MultiColumn.prototype = Object.assign({}, MultiColumn.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.multicolumn-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slide-index'));
      
      this.slideshow.select(slideIndex);
    },

    onBlockDeselect: function(evt) {
      // Resume Slideshow events
    }

  });

  return MultiColumn;
})();

theme.initQuickShop = function() {
  var ids = [];
  var products = document.querySelectorAll('[data-action="quick-view-trigger"]');

  products.forEach(product => {
    product.addEventListener('mouseover', productMouseover);
  });

  function productMouseover(evt) {
    var el = evt.currentTarget;
    el.removeEventListener('mouseover', productMouseover);
    if (!el || !el.dataset.productId) {
      // Onboarding product, no real data
      return;
    }
    var productId = el.dataset.productId;
    var handle = el.dataset.productHandle;
    var btn = el.querySelector('.Button--info');
    theme.preloadProductModal(handle, productId, btn);
  }
};

theme.initPackageQuickShop = function() {
  var ids = [];
  var products = document.querySelectorAll('.ProductPackage__Item-inner');

  products.forEach(product => {
    product.addEventListener('mouseover', productMouseover);
  });

  function productMouseover(evt) {
    var el = evt.currentTarget;
    el.removeEventListener('mouseover', productMouseover);
    if (!el || !el.dataset.productId) {
      // Onboarding product, no real data
      return;
    }
    var productId = el.dataset.productId;
    var handle = el.dataset.productHandle;
    var btn = el.querySelector('.Button--info');
    theme.preloadProductModal(handle, productId, btn);
  }
};

theme.initBottomProductQuickShop = function() {
  var ids = [];
  var products = document.querySelectorAll('.BottomProduct__inner');

  products.forEach(product => {
    product.addEventListener('mouseover', productMouseover);
  });

  function productMouseover(evt) {
    var el = evt.currentTarget;
    el.removeEventListener('mouseover', productMouseover);
    if (!el || !el.dataset.productId) {
      // Onboarding product, no real data
      return;
    }
    var productId = el.dataset.productId;
    var handle = el.dataset.productHandle;
    var btn = el.querySelector('.Button--info');
    theme.preloadProductModal(handle, productId, btn);
  }
};

theme.preloadProductModal = function(handle, productId, btn) {
  var holder = document.getElementById('QuickShopHolder-' + handle);
  var url = window.routes.home + '/products/' + handle + '?section_id=popup-product';

  // remove double `/` in case shop might have /en or language in URL
  url = url.replace('//', '/');

  // Setup quick view modal
  var modalId = 'QuickShopModal-' + productId;
  var name = 'quick-modal-' + productId;
  new theme.Modals(modalId, name);
  
  if (btn) {
    btn.classList.remove('quick-product__btn--not-ready');
  }
}

theme.CartBoxSlider = (function() {

  function CartBoxSlider(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = '#CartBox--' + sectionId;

    var config = {
      watchCSS: true,
      wrapAround: true,
      cellAlign: 'center',
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
    
    document.addEventListener('ajaxCartSections:updated', function(event) {
      // Re-init Slider when event excuted
      this.slideshow = new Flickity(slideshow, config);
    });
    
    // add this code
    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };

  }

  return CartBoxSlider;
})();

theme.FeaturedProductList = (function() {

  function FeaturedProductList(container) {
    var sectionId = container.dataset.sectionId;
    this.container = container;
    var slideshow = '#ProductList-' + sectionId;

    var config = {
      watchCSS: true,
      wrapAround: false,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: true,
      imagesLoaded: true
    }

    this.slideshow = new Flickity(slideshow, config);
  }
  
  FeaturedProductList.prototype = Object.assign({}, FeaturedProductList.prototype, {
    onUnload: function() {
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.ProductList-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slide-index'));
      
      this.slideshow.select(slideIndex);
    },

    onBlockDeselect: function(evt) {
      // Resume Slideshow events
    }

  });

  return FeaturedProductList;
})();


// AOS Fix for Section Events
document.addEventListener('shopify:section:load', function(){
  AOS.init();
});

document.addEventListener('shopify:block:select', function(){
  AOS.init();
});

document.addEventListener('reInitQuickShop:updated', function(event) {
  // Re-init CartQuikShop when event excuted
  theme.initPackageQuickShop();
  theme.initBottomProductQuickShop();
});

// Intialize all function on DOMLoaded
document.addEventListener('DOMContentLoaded', function () {
  var sections = new theme.Sections();

  new theme.Collapsible();
  new theme.Responsive();
  theme.initQuickShop();
  theme.initPackageQuickShop();
  theme.initBottomProductQuickShop();

  sections.register('header', theme.HeaderSection);
  sections.register('footer', theme.FooterSection);
  sections.register('recommendation-products', theme.RecommendationSlider);
  sections.register('cart-collection', theme.CartCollection);
  sections.register('main-influencer', theme.InfluencerDeal);
  sections.register('multi-column', theme.MultiColumn);
  sections.register('main-cart', theme.CartBoxSlider);
  sections.register('featured-product-list', theme.FeaturedProductList);

  AOS.init();
  
  /**
     * ----------------------------------------------------------------------------
     * FLICKITY
     *
     * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
     * event.preventDefault to be called on dynamically added listeners, which is
     * what Flickity is using.
     *
     * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
     * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
     * and that we are using here as a temporary workaround, that should be removed
     * once the bug is fixed on iOS
     * ----------------------------------------------------------------------------
     */

  Flickity.defaults.dragThreshold = 7;

  (function () {
    var touchingCarousel = false,
        touchStartCoords;
    document.body.addEventListener('touchstart', function (e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      };
    });
    document.body.addEventListener('touchmove', function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };
      if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
    }, {
      passive: false
    });
  })();
  /**
     * ----------------------------------------------------------------------------
     * FLICKITY 2
     *
     * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
     * the bottom bar as soon as you do even a minor diagonal movement. This is causing
     * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
     * patch Flickity to make sure they re-size the carousel only when the width is
     * changed, by ignoring the height
     * ----------------------------------------------------------------------------
     */


  (function () {
    if (window.Flickity) {
      var originalResizeMethod = window.Flickity.prototype.resize,
          lastWidth = window.innerWidth;

      window.Flickity.prototype.resize = function () {
        if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
          return;
        }

        lastWidth = window.innerWidth;
        originalResizeMethod.apply(this, arguments); // Call original method
      };
    }
  })();

  /**
     * ----------------------------------------------------------------------------
     * FLICKITY
     *
     * Equal Height Hack
     * ----------------------------------------------------------------------------
     */

    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };
  
  // Page Loaded Event
  document.dispatchEvent(new CustomEvent('page:loaded'));
  
});

(function () {
/**
    * ----------------------------------------------------------------------------
    * Size Chart
    * ----------------------------------------------------------------------------
    */
 (function () {
   	const modalTriggers = document.querySelectorAll('.popup-trigger');
    const modalCloseTrigger = document.querySelector('.popup-modal__close');
    const bodyBlackout = document.querySelector('.SizeChart__Overlay');

    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const { popupTrigger } = trigger.dataset;
        const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`);

        popupModal.classList.add('is--visible');
        bodyBlackout.classList.add('is-visible');

        popupModal.querySelector('.popup-modal__close').addEventListener('click', () => {
           popupModal.classList.remove('is--visible');
           bodyBlackout.classList.remove('is-visible');
        });

        bodyBlackout.addEventListener('click', () => {
          popupModal.classList.remove('is--visible');
          bodyBlackout.classList.remove('is-visible');
        });

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (evt.keyCode == 27) {
            popupModal.classList.remove('is--visible');
            bodyBlackout.classList.remove('is-visible');
          }
        };

      });
    });
 })();

})();


(function () {
/**
    * ----------------------------------------------------------------------------
    * RTE
    * ----------------------------------------------------------------------------
    */
 (function () {
   // We wrap each RTE table by a specific class to allow wrapping
   var Dom = document.body;
   Dom.querySelectorAll('.Rte table').forEach(function (table) {
     table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
   });
   Dom.querySelectorAll('.Rte iframe').forEach(function (iframe) {
     // We scope the wrapping only for YouTube and Vimeo
     if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
       iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
       // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

       iframe.src = iframe.src;
     }
   });
 })();

})();


// Cart Drawer Additional 
$(function(){
//   Sticky AddToCart bar
  if ($('body').hasClass('template-product')) {
    $(window).scroll(function() {
      var Product_up = $('.product__info-container').offset().top;
      var product_section_height = $('.product__info-container').outerHeight();
      var full_scroll = Product_up + product_section_height - $('.Header').outerHeight();
      if ($(this).scrollTop() > full_scroll) {
        $('body .product-sticky-container').addClass('active');
      } else {
        $('body .product-sticky-container').removeClass('active');
      }
    });
  }
  
  $('body').on('click', '.product-sticky .component-atc-button', function(e){
    e.preventDefault();
    $('.product-form .Product-form__submit').trigger('click');
  });
});

